export default (client, defaultParams) => ({
  get: (hash) => (
    client(`/lesson/${hash}`, {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  update: (hash, data) => (
    client(`/lesson/${hash}`, {
      method: 'PUT',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),
  remove: (hash) => (
    client(`/lesson/${hash}`, {
      method: 'DELETE',
      params: {
        ...defaultParams,
      },
    })
  ),
  create: (data) => (
    client('/lessons', {
      method: 'POST',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),

  getMessage: (k) => {
    const messages = {
    };
    return (messages[k] || k);
  },
});
